// import { useState, useEffect, useRef } from 'react';
// import { Box, Paper, Grid, TextField, Autocomplete, Typography, Button, Dialog, DialogContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableFooter } from '@mui/material';
// import axios from 'axios';
// import { useAuth } from '../../../context/AuthContext';
// import ClientMaster from '../../ClientMaster';
// import LeadSourceMaster from './LeadSourceMaster';
// import ActivityMaster from './ActivityMaster';
// import CurrencyMaster from '../../CurrencyMaster';
// import LeadStatusMaster from './LeadStatusMaster';
// import UserMaster from '../../UserMaster';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import dayjs from 'dayjs';
// import customParseFormat from 'dayjs/plugin/customParseFormat';
// import { useTheme, useMediaQuery } from '@mui/material';
// dayjs.extend(customParseFormat);


// const parseDate = (value) => {
//     if (value == null || value === '') return null;
//     if (dayjs.isDayjs(value)) return value.isValid() ? value : null;

//     const s = String(value).trim();
//     const formats = ['YYYY-MM-DD', 'YYYY/MM/DD', 'DD/MM/YYYY', 'DD-MM-YYYY', 'D/M/YYYY', 'D-M-YYYY'];
//     const d = dayjs(s, formats, true);
//     return d.isValid() ? d : null;
// };

// const transform = (data, idKey, valKey) => data.map(item => ({ id: item[idKey], label: item[valKey] }));

// export default function ClientDetails({ initialData = {}, onNext, mode, connectionString }) {
//     const { user, selectedCompany, loading } = useAuth();
//     const API = connectionString;
//     const partyDropdownRef = useRef(null);
//     // ─── client search state ─────────────────────────────────────────────
//     const [companyName, setCompanyName] = useState(initialData.companyName || '');
//     const [selectedClientId, setSelectedClientId] = useState(initialData.clientId || null);
//     const [searchResults, setSearchResults] = useState([]);
//     const [dropdownOpen, setDropdownOpen] = useState(false);
//     const [clientError, setClientError] = useState(false);
//     const [selectedCompanyName, setSelectedCompanyName] = useState("");

//     console.log("selectedCompanyName" , selectedCompanyName)

//     const theme = useTheme();
// const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

//     // ─── other form state ───────────────────────────────────────────────
//     const [details, setDetails] = useState(initialData.details || []);
//     const [error, setError] = useState('');
//     const [qoutationNumber, setqoutationNumber] = useState('');
//     const [isFetchingQuotation, setIsFetchingQuotation] = useState(false);
//     const [qoutationDate, setqoutationDate] = useState(dayjs());
//     const [referenceNumber, setReferenceNumber] = useState(initialData.referenceNumber || '');
//     const [referenceDate, setReferenceDate] = useState(null);
//     const [exchangeRate, setExchangeRate] = useState(initialData.exchangeRate || '');
//     const [qnextFollowUpDate, setqnextFollowUpDate] = useState(dayjs().add(7, 'day'));
//     const [kindAttend, setKindAttend] = useState(initialData.kindAttend || '');
//     const [project, setProject] = useState(initialData.project || '');
//     const [agentName, setAgentName] = useState(initialData.agentName || '');
//     const [agentCommission, setAgentCommission] = useState(initialData.agentCommission || '');
//     const [remark, setRemark] = useState(initialData.remark || initialData.remarks || '');

//     // ─── masters & popups ───────────────────────────────────────────────
//     const [currencyOptions, setCurrencyOptions] = useState([]);
//     const [selectedCurrency, setSelectedCurrency] = useState(null);
//     const [selectedLeadSource, setSelectedLeadSource] = useState(initialData.selectedLeadSource || null);
//     const [selectedEmployee, setSelectedEmployee] = useState(initialData.selectedEmployee || null);
//     const [selectedActivity, setSelectedActivity] = useState(initialData.selectedActivity || null);
//     const [selectedStatus, setSelectedStatus] = useState(initialData.selectedStatus || null);

//     const [openClientPopup, setOpenClientPopup] = useState(false);
//     const [openCurrencyPopup, setOpenCurrencyPopup] = useState(false);
//     const [openLeadSourcePopup, setOpenLeadSourcePopup] = useState(false);
//     const [openEmployeePopup, setOpenEmployeePopup] = useState(false);
//     const [openActivityPopup, setOpenActivityPopup] = useState(false);
//     const [openStatusPopup, setOpenStatusPopup] = useState(false);
//     const companyId = selectedCompany?.CompId || null;

//     async function fetchReceiptNo(code, retries = 3) {
//         for (let i = 0; i < retries; i++) {
//             try {
//                 console.log(`🌐 Attempt ${i + 1} to fetch quotation number from: ${API}/api/getQuotationNumber`);
//                 const { data } = await axios.get(`${API}/api/getQuotationNumber`, {
//                     headers: { 'Cache-Control': 'no-cache', },
//                     params: { companyId, },
//                 });
//                 if (data && data.newQuotationNumber) {
//                     console.log('📝 Setting qoutationNumber to:', data.newQuotationNumber);
//                     setqoutationNumber(data.newQuotationNumber);
//                     setIsFetchingQuotation(false);
//                     return;
//                 } else {
//                     console.warn('⚠️ No newQuotationNumber in response');
//                 }
//             } catch (err) {
//                 console.error(`❌ Attempt ${i + 1} failed:`, err.message);
//                 if (i === retries - 1) {
//                     console.error('❌ All retries failed');
//                     setqoutationNumber('');
//                     setError('Failed to fetch quotation number after retries.');
//                     setIsFetchingQuotation(false);
//                 }
//             }
//         }
//     }

//     // ─── load all master-lists ───────────────────────────────────────────
//     useEffect(() => {
//         const fetchMasters = async () => {
//             try {
//                 const [cur] = await Promise.all([axios.get(`${API}/currencymaster/search?mode=search&companyId=${companyId}`)]);
//                 setCurrencyOptions(
//                     Array.isArray(cur?.data)
//                         ? transform(cur?.data, 'CurrencyId', 'CurrencySymbol')
//                         : []
//                 );
//             } catch (err) {
//                 console.error('❌ Error fetching master data:', err.message);
//             }
//         };
//         fetchMasters();
//     }, []);

//     // when currency options load (or when initialData.currencyId changes), pick the matching option
//     useEffect(() => {
//         if (!currencyOptions || currencyOptions.length === 0) return;

//         const idToMatch = initialData?.currencyId ?? null;

//         if (idToMatch == null) return;

//         const found = currencyOptions.find(opt => Number(opt.id) === Number(idToMatch));
//         console.log(found);
//         if (found) {
//             console.log('✅ Setting selectedCurrency:', found);
//             setSelectedCurrency(found);
//         } else {
//             console.warn('⚠️ Currency ID not found in options:', idToMatch);
//             setSelectedCurrency(null);
//         }
//     }, [currencyOptions, initialData?.CurrencyId]);

//     const dropdownField = (label, options, value, setValue) => (
//         <Grid item xs={12} sm={8} md={12}>
//             <Autocomplete fullWidth options={options} getOptionLabel={opt => opt?.label || ''} value={value} onChange={(_, v) => setValue(v)} isOptionEqualToValue={(opt, val) => opt?.id === val?.id} freeSolo={!value} disableClearable={!!value}
//                 renderInput={params => (
//                     <TextField {...params} label={label} size="small" InputLabelProps={{ shrink: Boolean(value) }} inputProps={{ ...params.inputProps, readOnly: !!value }}
//                         sx={{
//                             '& .MuiOutlinedInput-root': { height: 40, display: 'flex', alignItems: 'center' },
//                             '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' },
//                         }}
//                     />
//                 )}
//             />
//         </Grid>
//     );

//     // ─── initialize from initialData ─────────────────────────────────────
//     // NEW CHANGE: Set referenceDate to inquiryDate in ref mode
//     useEffect(() => {
//         console.log('ClientDetails: initialData received:', JSON.stringify(initialData, null, 2));
//         if (!initialData || Object.keys(initialData).length === 0) {
//             setqoutationDate(dayjs());
//             setReferenceDate(null);
//             setqnextFollowUpDate(dayjs().add(7, 'day'));
//             setqoutationNumber('');
//             setReferenceNumber('');
//             setIsFetchingQuotation(false);
//             if (mode === 'add' || mode === 'inquiry' || mode === 'ref') {
//                 setIsFetchingQuotation(true);
//                 fetchReceiptNo('Q');
//             }
//             return;
//         }

//         setCompanyName(initialData.companyName || '');
//         setSelectedClientId(initialData.clientId ?? null);

//         if (mode === 'add' || mode === 'inquiry') {
//             setqoutationDate(dayjs());
//             setReferenceNumber(mode === 'inquiry' ? initialData.referenceNumber || '' : initialData.referenceNumber || '');
//             setReferenceDate(mode === 'inquiry' ? parseDate(initialData.inquiryDate) : parseDate(initialData.referenceDate));
//             setqnextFollowUpDate(dayjs().add(7, 'day'));
//             setIsFetchingQuotation(true);
//             fetchReceiptNo('Q');
//         } else if (mode === 'edit') {
//             setqoutationDate(parseDate(initialData.inquiryDate) || dayjs());
//             // Check all possible keys for referenceNumber
//             setReferenceNumber(
//                 initialData.referenceNumber ||
//                 initialData.editreferenceNumber ||
//                 initialData.inquiryNumber ||
//                 ''
//             );
//             setReferenceDate(parseDate(initialData.referenceDate));
//             setqnextFollowUpDate(parseDate(initialData.nextFollowUpDate) || dayjs().add(7, 'day'));
//             setqoutationNumber(initialData.qoutationNumber || '');
//             setIsFetchingQuotation(false);
//         } else if (mode === 'ref') {
//             setqoutationDate(dayjs());
//             setReferenceNumber(initialData.inquiryNumber || '');
//             setReferenceDate(parseDate(initialData.inquiryDate));
//             setqnextFollowUpDate(dayjs().add(7, 'day'));
//             setIsFetchingQuotation(true);
//             fetchReceiptNo('Q'); // Generate new quotation number
//         } else {
//             console.warn('⚠️ Unknown mode:', mode);
//             setqoutationDate(dayjs());
//             setReferenceDate(null);
//             setqnextFollowUpDate(dayjs().add(7, 'day'));
//             setqoutationNumber('');
//             setReferenceNumber('');
//             setIsFetchingQuotation(false);
//         }

//         setExchangeRate(initialData.exchangeRate || '');
//         setKindAttend(initialData.kindAttend || '');
//         setProject(initialData.project || '');
//         setAgentName(initialData.agentName || '');
//         setAgentCommission(initialData.agentCommission || '');
//         setRemark(initialData.remark || initialData.remarks || '');
//         setSelectedLeadSource(initialData.selectedLeadSource || null);
//         setSelectedEmployee(initialData.selectedEmployee || null);
//         setSelectedActivity(initialData.selectedActivity || null);
//         setSelectedStatus(initialData.selectedStatus || null);

//         if (initialData.details) {
//             if (Array.isArray(initialData.details)) {
//                 setDetails(initialData.details);
//             } else if (typeof initialData.details === 'object') {
//                 const arr = Object.entries(initialData.details).map(([label, value]) => ({ label, value }));
//                 setDetails(arr);
//             }
//         } else {
//             setDetails([
//                 { label: 'City', value: '' },
//                 { label: 'State', value: '' },
//                 { label: 'mobileNo', value: '' },
//                 { label: 'Email', value: '' },
//                 { label: 'ContactPerson', value: '' },
//                 { label: 'GST No.', value: '' },
//             ]);
//         }
//     }, [initialData, mode]);
//     // END NEW CHANGE

//     // ─── fetch search results ─────────────────────────────────────────────
//     useEffect(() => {
//         if (!companyName || !dropdownOpen) {
//             setSearchResults([]);
//             return;
//         }

//         const fetch = async () => {
//             try {
//                 console.log('🌐 Fetching company search results for:', companyName);
//                 const res = await axios.get(`${API}/api/company-search`, { params: { field: 'FirmName', search: companyName, companyId } });
//                 // const data = Array.isArray(res.data.data) ? res.data.data : [];
//                 const data = Array.isArray(res.data?.data) ? res.data.data : res.data;
//                 console.log('✅ Company search results:', data);
//                 setSearchResults(data);
//             } catch (err) {
//                 console.error('❌ Error fetching company search:', err.message);
//                 setSearchResults([]);
//             }
//         };
//         fetch();
//     }, [companyName, dropdownOpen]);

//     // ─── when the user clicks a row in the table ──────────────────────────
//     const onSelectResult = r => {
//         console.log('✅ Selected company:', r);
//         setSelectedClientId(r.id);
//         setCompanyName(r.FirmName);
//         setAgentName(r.AgentName || '');
//         setAgentCommission(r.AgentComm || '');

//         const c = { city: r.City || '', state: r.state || '', mobileNo: r.MobileNo || '', emailId: r.EmailId || '', contactPerson: r.ContactPerson || '', gstNumber: r.GSTNo || '' };
//         setDetails([
//             { label: 'City', value: c.city },
//             { label: 'State', value: c.state },
//             { label: 'mobileNo', value: c.mobileNo },
//             { label: 'Email', value: c.emailId },
//             { label: 'ContactPerson', value: c.contactPerson },
//             { label: 'GST No.', value: c.gstNumber }
//         ]);
//         setDropdownOpen(false);
//     };

//     // ─── Next button ─────────────────────────────────────────────────────
//     const handleNext = () => {
//         if (!companyName || !qoutationNumber) {
//             console.warn('⚠️ Validation failed: Party & Inquiry No. are required');
//             setError('Party & Inquiry No. are required.');
//             return;
//         }
//         if (new Date(qnextFollowUpDate) < new Date(qoutationDate)) {
//             console.warn('⚠️ Validation failed: Next follow-up must be after inquiry date');
//             setError('Next follow-up must be after inquiry date.');
//             return;
//         }
//         setError('');

//         onNext({
//             clientId: selectedClientId,
//             companyName,
//             qoutationNumber,
//             inquiryDate: qoutationDate ? qoutationDate.format('DD/MM/YYYY') : null,
//             referenceNumber,
//             referenceDate: referenceDate ? referenceDate.format('DD/MM/YYYY') : null,
//             agentName,
//             agentCommission,
//             currencyId: selectedCurrency?.id || null,
//             exchangeRate: exchangeRate,
//             nextFollowUpDate: qnextFollowUpDate.format('DD/MM/YYYY'),
//             kindAttend,
//             remarks: remark,
//             project,
//             selectedEmployee,
//             selectedLeadSource,
//             selectedActivity,
//             selectedStatus,
//             details: details.reduce((acc, curr) => {
//                 acc[curr.label] = curr.value;
//                 return acc;
//             }, {})
//         });
//     };





//     // allow editing only in 'add' or 'edit' modes
//     const isEditable = mode === 'add' || mode === 'edit';

//     const clientExists = searchResults.some(
//   r => r.FirmName?.toLowerCase() === companyName.trim().toLowerCase()
// );

// // useEffect(() => {
// //   if (selectedCompanyName && companyName !== selectedCompanyName) {
// //     setSelectedCompanyName("");
// //   }
// // }, [companyName]);

// useEffect(() => {
//   if (
//     dropdownOpen === false &&
//     companyName?.trim() &&
//     !selectedCompanyName &&
//     !initialData?.companyName   // ⬅️ KEY
//   ) {
//     setClientError(true);
//   }
// }, [dropdownOpen]);

// useEffect(() => {
//   if (
//     initialData?.companyName &&
//     !selectedCompanyName
//   ) {
//     setSelectedCompanyName(initialData.companyName);
//     setClientError(false);
//   }
// }, [initialData?.companyName]);



//     return (
//         <Paper elevation={2} sx={{ p: 3, mb: 4 }}>
//             <Box display="flex" justifyContent="space-between" flexWrap="wrap" pt={1}>
//                 <Box sx={{ width: { xs: "100%", md: "calc(50% - 16px)" }, pr: { md: 3 } }}>
//                     {/* Party dropdown */}
//                     <Box ref={partyDropdownRef} tabIndex={-1} sx={{ position: 'relative', flex: '1 1 40%' }}
//                         onBlur={e => {
//                             if (!partyDropdownRef.current.contains(e.relatedTarget)) {
//                                 setDropdownOpen(false);
//                             }
//                         }}
//                     >
//                         {/* <TextField disabled={!isEditable} fullWidth size="small" label="Party Name" variant="outlined" value={companyName} required InputLabelProps={{ shrink: Boolean(companyName) }}
//                             sx={{ '& .MuiOutlinedInput-root': { height: '40px', display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { padding: '0 12px' } }}
//                             onChange={e => {
//                                 setCompanyName(e.target.value);
//                                 setDropdownOpen(true);
//                             }}
//                         /> */}
//                         <TextField
//   disabled={!isEditable}
//   fullWidth
//   size="small"
//   label="Party Name"
//   variant="outlined"
//   value={companyName}
//   required
//   error={clientError}
//   helperText={
//     clientError ? "Client does not exist. Please add new client or select from dropdown" : ""
//   }
//   InputLabelProps={{ shrink: Boolean(companyName) }}
//   sx={{
//     '& .MuiOutlinedInput-root': {
//       height: '40px',
//       display: 'flex',
//       alignItems: 'center'
//     },
//     '& .MuiOutlinedInput-input': { padding: '0 12px' }
//   }}
//   onChange={(e) => {
//   const value = e.target.value;
//   setCompanyName(value);
//   setDropdownOpen(true);

//   setSelectedCompanyName("");   // ❗ reset selection
//   setClientError(false);
// }}
// />

// {dropdownOpen && companyName && (
//   <Paper
//     elevation={0}
//     sx={{
//       mt: 1,
//       position: 'absolute',
//       width: { xs: '100%', lg: '800px' },
//       zIndex: 10,
//       border: '1px solid rgba(0,0,0,0.2)',
//       borderRadius: 1,
//       maxHeight: 240,
//       overflowY: 'auto'
//     }}
//   >
//     {isSmallScreen ? (
//       /* ===================== CARD VIEW (SM / XS) ===================== */
//       <>
//         {searchResults.length > 0 ? (
//           searchResults.map((r, i) => (
//             <Box
//               key={i}
//               sx={{
//                 p: 1.2,
//                 borderBottom: '1px solid #eee',
//                 cursor: 'pointer'
//               }}
//               onMouseDown={() => {
//                 onSelectResult(r);
//                 setCompanyName(r.FirmName);
//                 setSelectedCompanyName(r.FirmName);
//                 setClientError(false);
//                 setDropdownOpen(false);
//               }}
//             >
//               <Box sx={{ fontWeight: 600, fontSize: '0.85rem' }}>
//                 {r.FirmName}
//               </Box>

//               <Box sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
//                 GST: {r.GSTNo || '-'}
//               </Box>

//               <Box sx={{ fontSize: '0.75rem' }}>
//                 {r.ContactPerson || '-'} • {r.MobileNo || '-'}
//               </Box>

//               <Box sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
//                 {r.City || '-'}
//               </Box>
//             </Box>
//           ))
//         ) : (
//           <Box sx={{ p: 2, textAlign: 'center', color: 'error.main' }}>
//             Client not found
//           </Box>
//         )}

//         {/* Sticky Add New Client */}
//         <Box
//           sx={{
//             position: 'sticky',
//             bottom: 0,
//             backgroundColor: '#fff',
//             textAlign: 'center',
//             p: 1,
//             fontWeight: 600,
//             color: 'primary.main',
//             cursor: 'pointer',
//             boxShadow: '0 -2px 6px rgba(0,0,0,0.08)'
//           }}
//           onMouseDown={() => setOpenClientPopup(true)}
//         >
//           ➕ Add New Client
//         </Box>
//       </>
//     ) : (
//       /* ===================== TABLE VIEW (MD / LG) ===================== */
//       <Table size="small" stickyHeader>
//         <TableHead>
//           <TableRow>
//             {['Company', 'GST No', 'Contact', 'Mobile', 'City'].map(h => (
//               <TableCell
//                 key={h}
//                 sx={{
//                   backgroundColor: '#E0E0E0',
//                   fontWeight: 600,
//                   fontSize: '0.75rem',
//                   position: 'sticky',
//                   top: 0,
//                   zIndex: 1
//                 }}
//               >
//                 {h}
//               </TableCell>
//             ))}
//           </TableRow>
//         </TableHead>

//         <TableBody>
//           {searchResults.length > 0 ? (
//             searchResults.map((r, i) => (
//               <TableRow
//                 key={i}
//                 hover
//                 sx={{ cursor: 'pointer' }}
//                 onMouseDown={() => {
//                   onSelectResult(r);
//                   setCompanyName(r.FirmName);
//                   setSelectedCompanyName(r.FirmName);
//                   setClientError(false);
//                   setDropdownOpen(false);
//                 }}
//               >
//                 <TableCell>{r.FirmName}</TableCell>
//                 <TableCell>{r.GSTNo}</TableCell>
//                 <TableCell>{r.ContactPerson}</TableCell>
//                 <TableCell>{r.MobileNo}</TableCell>
//                 <TableCell>{r.City}</TableCell>
//               </TableRow>
//             ))
//           ) : (
//             <TableRow>
//               <TableCell colSpan={5} align="center" sx={{ color: 'error.main' }}>
//                 Client not found
//               </TableCell>
//             </TableRow>
//           )}
//         </TableBody>

//         <TableFooter
//           sx={{
//             position: 'sticky',
//             bottom: 0,
//             backgroundColor: '#fff'
//           }}
//         >
//           <TableRow hover onMouseDown={() => setOpenClientPopup(true)}>
//             <TableCell colSpan={5} align="center" sx={{ color: 'primary.main', fontWeight: 600 }}>
//               ➕ Add New Client
//             </TableCell>
//           </TableRow>
//         </TableFooter>
//       </Table>
//     )}
//   </Paper>
// )}


//                     </Box>

//                     {/* Details display */}
//                     <Grid item xs={12} md={4} pt={2}>
//                         <TextField fullWidth size="small" label="Address" variant="outlined" disabled value={Array.isArray(details) ? details.map(d => `${d.label}: ${d.value}`).join(', ') : ''} multiline rows={3.4}
//                             InputLabelProps={{ shrink: Array.isArray(details) && details.length > 0 }}
//                             sx={{
//                                 '& .MuiOutlinedInput-root': { display: 'flex', alignItems: 'center' },
//                                 '& .MuiOutlinedInput-input': { padding: '0 12px' }
//                             }}
//                         />
//                     </Grid>

//                     <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <TextField fullWidth size="small" label="Kind Attend" value={kindAttend} onChange={e => setKindAttend(e.target.value)} InputLabelProps={{ shrink: Boolean(kindAttend) }}
//                                 sx={{
//                                     '& .MuiOutlinedInput-root': { height: 40, display: 'flex', alignItems: 'center' },
//                                     '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
//                                 }}
//                             />
//                         </Box>
//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <TextField fullWidth size="small" label="Project" value={project} onChange={e => setProject(e.target.value)} InputLabelProps={{ shrink: Boolean(project) }}
//                                 sx={{
//                                     '& .MuiOutlinedInput-root': { height: 40, display: 'flex', alignItems: 'center' },
//                                     '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
//                                 }}
//                             />
//                         </Box>
//                     </Box>
//                     {/* Remark multiline (max 250 chars) */}
//                     <Box sx={{ mt: 2 }}>
//                         <TextField fullWidth size="small" label="Remark" disabled={!isEditable} multiline minRows={3} maxRows={6} value={remark} InputLabelProps={{ shrink: Boolean(remark) }} inputProps={{ maxLength: 250 }}
//                             onChange={(e) => {
//                                 const val = e.target.value;
//                                 if (val.length <= 250) setRemark(val);
//                                 else setRemark(val.slice(0, 250));
//                             }}
//                             sx={{
//                                 '& .MuiOutlinedInput-root': { height: 'auto', alignItems: 'flex-start' },
//                                 '& .MuiOutlinedInput-input': { padding: '10px 12px' }
//                             }}
//                         />
//                         <Typography variant="caption" sx={{ display: 'block', mt: 0.5, textAlign: 'right', color: 'text.secondary' }}>
//                             {remark.length}/250
//                         </Typography>
//                     </Box>
//                 </Box>

//                 <Box sx={{ width: { xs: "100%", md: "calc(50% - 46px)" }, pt: { xs: 2, md: 0 } }} alignSelf="right">
//                     {/* Quotation No + Date */}
//                     <Box display="flex" gap={2} flex="1 1 40%" >
//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <TextField key={qoutationNumber} fullWidth size="small" label="Quotation No." variant='outlined' value={isFetchingQuotation ? 'Loading...' : qoutationNumber} disabled InputLabelProps={{ shrink: true }}
//                                 sx={{
//                                     '& .MuiOutlinedInput-root': { height: 40, display: 'flex', alignItems: 'center' },
//                                     '& .MuiOutlinedInput-input': { padding: '0 12px' }
//                                 }}
//                             />
//                         </Box>

//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
//                                 <DatePicker label="Quotation Date" value={qoutationDate} onChange={setqoutationDate} disabled
//                                     slots={{
//                                         textField: (params) => (
//                                             <TextField {...params} size="small" variant="outlined" value={qoutationDate ? dayjs(qoutationDate).format('DD/MM/YYYY') : ''} InputLabelProps={{ shrink: true }}
//                                                 sx={{
//                                                     '& .MuiOutlinedInput-root': { height: 40, display: 'flex', alignItems: 'center' },
//                                                     '& .MuiOutlinedInput-input': { padding: '0 12px' }
//                                                 }}
//                                             />
//                                         ),
//                                     }}
//                                 />
//                             </LocalizationProvider>
//                         </Box>
//                     </Box>

//                     <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
//                         {/* Ref. No. */}
//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <TextField fullWidth size="small" variant='outlined' label="Ref. No." value={referenceNumber} onChange={e => setReferenceNumber(e.target.value)} InputLabelProps={{ shrink: Boolean(referenceNumber) }}
//                                 sx={{
//                                     '& .MuiOutlinedInput-root': { height: 40, display: 'flex', alignItems: 'center' },
//                                     '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
//                                 }}
//                             />
//                         </Box>

//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
//                                 <DatePicker label="Ref. Date" value={referenceDate} onChange={(newValue) => { setReferenceDate(newValue); }}
//                                     slots={{
//                                         textField: (params) => (
//                                             <TextField {...params} fullWidth size="small" variant="outlined" value={referenceDate ? dayjs(referenceDate).format('DD/MM/YYYY') : ''} InputLabelProps={{ shrink: Boolean(referenceDate) }}
//                                                 sx={{
//                                                     '& .MuiOutlinedInput-root': { height: 40, display: 'flex', alignItems: 'center' },
//                                                     '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
//                                                 }}
//                                             />
//                                         )
//                                     }}
//                                 />
//                             </LocalizationProvider>
//                         </Box>
//                     </Box>

//                     <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
//                         {/* Combined Left Group */}
//                         <Box sx={{ flex: '0 0 48%', display: 'flex', gap: 1, alignItems: 'center' }}>
//                             {/* Currency dropdown at 50% of this group */}
//                             <Box sx={{ flex: '0 0 50%' }}>
//                                 {dropdownField('Currency', currencyOptions, selectedCurrency, setSelectedCurrency)}
//                             </Box>

//                             {/* Exchange Rate at 47% of this group */}
//                             <Box sx={{ flex: '0 0 47%' }}>
//                                 <TextField fullWidth size="small" type="number" variant="outlined" label="Ex Rate" value={exchangeRate} InputLabelProps={{ shrink: Boolean(exchangeRate) }}
//                                     onChange={(e) => {
//                                         const value = e.target.value;
//                                         if (/^\d*\.?\d{0,2}$/.test(value)) {
//                                             setExchangeRate(value);
//                                         }
//                                     }}
//                                     sx={{
//                                         '& .MuiOutlinedInput-root': { height: 40, display: 'flex', alignItems: 'center' },
//                                         '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
//                                     }}
//                                 />
//                             </Box>
//                         </Box>

//                         {/* Right group: Follow-Up Date */}
//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
//                                 <DatePicker minDate={qoutationDate ? dayjs(qoutationDate) : undefined} label="Follow Up Date" value={qnextFollowUpDate} onChange={(newValue) => { setqnextFollowUpDate(newValue); }}
//                                     slots={{
//                                         textField: (params) => (
//                                             <TextField {...params} fullWidth size="small" variant="outlined" value={qnextFollowUpDate ? qnextFollowUpDate.format('DD/MM/YYYY') : ''} InputLabelProps={{ shrink: Boolean(qnextFollowUpDate) }}
//                                                 sx={{
//                                                     '& .MuiOutlinedInput-root': { height: 40, display: 'flex', alignItems: 'center' },
//                                                     '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
//                                                 }}
//                                             />
//                                         )
//                                     }}
//                                 />
//                             </LocalizationProvider>
//                         </Box>
//                     </Box>

//                     <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <TextField fullWidth label="Agent Name" value={agentName} onChange={e => setAgentName(e.target.value)} InputLabelProps={{ shrink: Boolean(agentName) }} variant="outlined" size="small"
//                                 sx={{
//                                     '& .MuiOutlinedInput-root': { backgroundColor: 'white', height: '40px' },
//                                     '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 10px' }
//                                 }}
//                             />
//                         </Box>

//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <TextField fullWidth label="Agent Commission (%)" value={agentCommission} InputLabelProps={{ shrink: Boolean(agentCommission) }} variant="outlined" size="small" type="number"
//                                 onChange={e => {
//                                     const v = e.target.value;
//                                     if (v === '') {
//                                         setAgentCommission('');
//                                         return;
//                                     }
//                                     const re = /^(?:100(?:\.(?:0{0,2}))?|[0-9]{1,2}(?:\.\d{0,2})?)$/;
//                                     if (re.test(v)) {
//                                         setAgentCommission(v);
//                                     }
//                                 }}
//                                 sx={{
//                                     '& .MuiOutlinedInput-root': { backgroundColor: 'white', height: '40px' },
//                                     '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 10px' }
//                                 }}
//                             />
//                         </Box>
//                     </Box>
//                 </Box>
//             </Box>

//             {!!error && (
//                 <Typography color="error" mt={2}>
//                     {error}
//                 </Typography>
//             )}

//             {isFetchingQuotation && (
//                 <Typography color="text.secondary" mt={2}>
//                     Loading quotation number...
//                 </Typography>
//             )}

//             <Box mt={2} display="flex" justifyContent="flex-end">
//                 <Button variant="contained" onClick={handleNext} disabled={isFetchingQuotation || clientError || !selectedCompanyName}> Next </Button>
//             </Box>

//             {/* Popups */}
//             <Dialog open={openClientPopup} keepMounted fullWidth maxWidth="md" onClose={() => setOpenClientPopup(false)}>
//                 <DialogContent>
//                     <ClientMaster mode="add" onPopupCancel={() => setOpenClientPopup(false)} connectionString={connectionString} />
//                 </DialogContent>
//             </Dialog>
//             <Dialog open={openCurrencyPopup} keepMounted onClose={() => setOpenCurrencyPopup(false)}>
//                 <DialogContent>
//                     <CurrencyMaster mode="add" onPopupCancel={() => setOpenCurrencyPopup(false)} connectionString={connectionString} />
//                 </DialogContent>
//             </Dialog>
//             <Dialog open={openLeadSourcePopup} keepMounted onClose={() => setOpenLeadSourcePopup(false)}>
//                 <DialogContent>
//                     <LeadSourceMaster mode="add" onPopupCancel={() => setOpenLeadSourcePopup(false)} connectionString={connectionString} />
//                 </DialogContent>
//             </Dialog>
//             <Dialog open={openEmployeePopup} keepMounted onClose={() => setOpenEmployeePopup(false)}>
//                 <DialogContent>
//                     <UserMaster mode="add" onPopupCancel={() => setOpenEmployeePopup(false)} connectionString={connectionString} />
//                 </DialogContent>
//             </Dialog>
//             <Dialog open={openActivityPopup} keepMounted onClose={() => setOpenActivityPopup(false)}>
//                 <DialogContent>
//                     <ActivityMaster mode="add" onPopupCancel={() => setOpenActivityPopup(false)} connectionString={connectionString} />
//                 </DialogContent>
//             </Dialog>
//             <Dialog open={openStatusPopup} keepMounted onClose={() => setOpenStatusPopup(false)}>
//                 <DialogContent>
//                     <LeadStatusMaster mode="add" onPopupCancel={() => setOpenStatusPopup(false)} connectionString={connectionString} />
//                 </DialogContent>
//             </Dialog>
//         </Paper>
//     );
// }




import { colors as themeColors } from '../../../utils/theme';
import { useState, useEffect, useRef } from 'react';
import { Box, Paper, Grid, TextField, Autocomplete, Typography, Button, Dialog, DialogContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableFooter, Snackbar, Alert } from '@mui/material';
import axios from 'axios';
import { useAuth } from '../../../context/AuthContext';
import { useConfigure } from '../../../context/ConfigureContext';
import ClientMaster from '../../ClientMaster';
import LeadSourceMaster from './LeadSourceMaster';
import ActivityMaster from './ActivityMaster';
import CurrencyMaster from '../../CurrencyMaster';
import LeadStatusMaster from './LeadStatusMaster';
import UserMaster from '../../UserMaster';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { useTheme, useMediaQuery } from '@mui/material';
import { toProperCase } from '../../../utils/formatRows';
import { getFinancialYearBounds } from '../../../utils/financialYear';
dayjs.extend(customParseFormat);

const parseDate = (value) => {
    if (value == null || value === '') return null;
    if (dayjs.isDayjs(value)) return value.isValid() ? value : null;

    const s = String(value).trim();
    const formats = ['YYYY-MM-DD', 'YYYY/MM/DD', 'DD/MM/YYYY', 'DD-MM-YYYY', 'D/M/YYYY', 'D-M-YYYY'];
    const d = dayjs(s, formats, true);
    return d.isValid() ? d : null;
};

const transform = (data, idKey, valKey) => data.map(item => ({ id: item[idKey], label: item[valKey] }));

export default function ClientDetails({ initialData = {}, onNext, mode, connectionString, disablePartyName = false, disablePartyNameEdit = false, isQuotationLocked = false }) {
    const { user, selectedCompany, loading } = useAuth();
    const { isFeatureEnabled } = useConfigure();
    const showCurrency = isFeatureEnabled('Show Currency?');
    const API = connectionString;
    const partyDropdownRef = useRef(null);
    // ─── client search state ─────────────────────────────────────────────
    const [companyName, setCompanyName] = useState(initialData.companyName || '');
    const [selectedClientId, setSelectedClientId] = useState(initialData.clientId || null);
    const [searchResults, setSearchResults] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [clientError, setClientError] = useState(false);
    const [highlightedIndex, setHighlightedIndex] = useState(0);

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    // ─── other form state ───────────────────────────────────────────────
    const [details, setDetails] = useState(initialData.details || []);
    const [error, setError] = useState('');
    const [qoutationNumber, setqoutationNumber] = useState('');
    const [isFetchingQuotation, setIsFetchingQuotation] = useState(false);
    const [qoutationDate, setqoutationDate] = useState(dayjs());
    const { startDate, endDate } = getFinancialYearBounds();
    const [referenceNumber, setReferenceNumber] = useState(initialData.referenceNumber || '');
    const [referenceDate, setReferenceDate] = useState(null);
    const [exchangeRate, setExchangeRate] = useState(initialData.exchangeRate || '');
    const [qnextFollowUpDate, setqnextFollowUpDate] = useState(dayjs().add(7, 'day'));
    const [kindAttend, setKindAttend] = useState(initialData.kindAttend || '');
    const [project, setProject] = useState(initialData.project || '');
    const [agentName, setAgentName] = useState(initialData.agentName || '');
    const [agentCommission, setAgentCommission] = useState(initialData.agentCommission || '');
    const [remark, setRemark] = useState(initialData.remark || initialData.remarks || '');

    // ─── masters & popups ───────────────────────────────────────────────
    const [currencyOptions, setCurrencyOptions] = useState([]);
    const [selectedCurrency, setSelectedCurrency] = useState(null);
    const [selectedLeadSource, setSelectedLeadSource] = useState(initialData.selectedLeadSource || null);
    const [selectedEmployee, setSelectedEmployee] = useState(initialData.selectedEmployee || null);
    const [selectedActivity, setSelectedActivity] = useState(initialData.selectedActivity || null);
    const [selectedStatus, setSelectedStatus] = useState(initialData.selectedStatus || null);

    const [openClientPopup, setOpenClientPopup] = useState(false);
    const [openCurrencyPopup, setOpenCurrencyPopup] = useState(false);
    const [openLeadSourcePopup, setOpenLeadSourcePopup] = useState(false);
    const [openEmployeePopup, setOpenEmployeePopup] = useState(false);
    const [openActivityPopup, setOpenActivityPopup] = useState(false);
    const [openStatusPopup, setOpenStatusPopup] = useState(false);
    const companyId = selectedCompany?.CompId || null;
    const isEditLocked = mode === 'edit' && isQuotationLocked;
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
    const requiredAsteriskStyle = { '& .MuiFormLabel-asterisk': { color: 'red', }, };

    const [termsOptions, setTermsOptions] = useState([]);
    const [selectedTerms, setSelectedTerms] = useState(initialData.selectedTerms || null);
    const [termsInputValue, setTermsInputValue] = useState('');


    const fetchLastTerms = async () => {
        try {
            const res = await axios.get(`${API}/api/last-terms-type`, {
                params: {
                    mode: 'SaleOrder',
                    companyId
                }
            });

            const termsValue = res?.data?.TermsType;

            console.log("modeee", mode)

            // Only for add/ref mode
            if (
                termsValue &&
                (mode === 'add')
            ) {
                setSelectedTerms({
                    label: String(termsValue)
                });
            }

        } catch (err) {
            console.error("Error fetching last terms", err);
        }
    };


    useEffect(() => {
        const fetchTerms = async () => {
            try {
                const { data: response } = await axios.get(`${API}/api/termscondition/search`, {
                    params: { companyId, mode: 'search' },
                    validateStatus: (status) => status >= 200 && status < 400,
                });
                const data = Array.isArray(response?.data) ? response.data : Array.isArray(response) ? response : [];
                console.log(data)
                const options = data.map(item => ({
                    label: item.TermsType || item.TermsName || ''
                }));
                setTermsOptions(options);
            } catch (err) {
                console.error('Error fetching terms:', err);
                setTermsOptions([]);
            }
        };

        if (companyId) {
            fetchTerms();
            fetchLastTerms();
        }


    }, [companyId]);


    async function fetchReceiptNo(code, retries = 3) {
        for (let i = 0; i < retries; i++) {
            try {
                console.log(`🌐 Attempt ${i + 1} to fetch quotation number from: ${API}/api/getQuotationNumber`);
                const { data } = await axios.get(`${API}/api/getQuotationNumber`, { headers: { 'Cache-Control': 'no-cache', }, params: { companyId, }, });
                if (data && data.newQuotationNumber) {
                    console.log('📝 Setting qoutationNumber to:', data.newQuotationNumber);
                    setqoutationNumber(data.newQuotationNumber);
                    setIsFetchingQuotation(false);
                    return;
                } else {
                    console.warn('⚠️ No newQuotationNumber in response');
                }
            } catch (err) {
                console.error(`❌ Attempt ${i + 1} failed:`, err.message);
                if (i === retries - 1) {
                    console.error('❌ All retries failed');
                    setqoutationNumber('');
                    setError('Failed to fetch quotation number after retries.');
                    setIsFetchingQuotation(false);
                }
            }
        }
    }

    // ─── load all master-lists ───────────────────────────────────────────
    useEffect(() => {
        const fetchMasters = async () => {
            try {
                const [cur] = await Promise.all([axios.get(`${API}/currencymaster/search?mode=search&companyId=${companyId}`)]);
                setCurrencyOptions(Array.isArray(cur?.data) ? transform(cur?.data, 'CurrencyId', 'CurrencySymbol') : []);
            } catch (err) {
                console.error('❌ Error fetching master data:', err.message);
            }
        };
        fetchMasters();
    }, []);

    // when currency options load (or when initialData.currencyId changes), pick the matching option
    useEffect(() => {
        if (!currencyOptions || currencyOptions.length === 0) return;
        const idToMatch = initialData?.currencyId ?? null;
        if (idToMatch == null) return;
        const found = currencyOptions.find(opt => Number(opt.id) === Number(idToMatch));
        console.log(found);
        if (found) {
            console.log('✅ Setting selectedCurrency:', found);
            setSelectedCurrency(found);
        } else {
            console.warn('⚠️ Currency ID not found in options:', idToMatch);
            setSelectedCurrency(null);
        }
    }, [currencyOptions, initialData?.CurrencyId]);

    const dropdownField = (label, options, value, setValue) => (
        <Grid item xs={12} sm={8} md={12}>
            <Autocomplete fullWidth options={options} getOptionLabel={opt => opt?.label || ''} value={value} onChange={(_, v) => setValue(v)} isOptionEqualToValue={(opt, val) => opt?.id === val?.id} freeSolo={!value} disableClearable={!!value}
                renderInput={params => (
                    <TextField {...params} label={label} size="small" InputLabelProps={{ shrink: Boolean(value) }} inputProps={{ ...params.inputProps, readOnly: !!value }} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }, }} />
                )}
            />
        </Grid>
    );

    // ─── initialize from initialData ─────────────────────────────────────
    // NEW CHANGE: Set referenceDate to inquiryDate in ref mode
    useEffect(() => {
        console.log('ClientDetails: initialData received:', JSON.stringify(initialData, null, 2));
        if (!initialData || Object.keys(initialData).length === 0) {
            setqoutationDate(dayjs());
            setReferenceDate(null);
            setqnextFollowUpDate(dayjs().add(7, 'day'));
            setqoutationNumber('');
            setReferenceNumber('');
            setIsFetchingQuotation(false);
            if (mode === 'add' || mode === 'inquiry' || mode === 'ref') {
                setIsFetchingQuotation(true);
                fetchReceiptNo('Q');
            }
            return;
        }

        setCompanyName(initialData.companyName || '');
        setSelectedClientId(initialData.clientId ?? null);

        if (mode === 'edit') {
            setSelectedTerms(
                initialData.TermsType
                    ? {
                        id: initialData.TermsType,
                        label: String(initialData.TermsType)
                    }
                    : null
            );
        }

        if (mode === 'add' || mode === 'inquiry') {
            setqoutationDate(dayjs());
            setReferenceNumber(mode === 'inquiry' ? initialData.referenceNumber || '' : initialData.referenceNumber || '');
            setReferenceDate(mode === 'inquiry' ? parseDate(initialData.inquiryDate) : parseDate(initialData.referenceDate));
            setqnextFollowUpDate(dayjs().add(7, 'day'));
            setIsFetchingQuotation(true);
            fetchReceiptNo('Q');
        } else if (mode === 'edit') {
            setqoutationDate(parseDate(initialData.inquiryDate) || dayjs());
            // Check all possible keys for referenceNumber
            setReferenceNumber(
                initialData.referenceNumber ||
                initialData.editreferenceNumber ||
                initialData.inquiryNumber ||
                ''
            );
            setReferenceDate(parseDate(initialData.referenceDate));
            setqnextFollowUpDate(parseDate(initialData.nextFollowUpDate) || dayjs().add(7, 'day'));
            setqoutationNumber(initialData.qoutationNumber || '');
            setIsFetchingQuotation(false);
        } else if (mode === 'ref') {
            setqoutationDate(dayjs());
            setReferenceNumber(initialData.inquiryNumber || '');
            setReferenceDate(parseDate(initialData.inquiryDate));
            setqnextFollowUpDate(dayjs().add(7, 'day'));
            setIsFetchingQuotation(true);
            fetchReceiptNo('Q'); // Generate new quotation number
        } else {
            console.warn('⚠️ Unknown mode:', mode);
            setqoutationDate(dayjs());
            setReferenceDate(null);
            setqnextFollowUpDate(dayjs().add(7, 'day'));
            setqoutationNumber('');
            setReferenceNumber('');
            setIsFetchingQuotation(false);
        }

        setExchangeRate(initialData.exchangeRate || '');
        setKindAttend(initialData.kindAttend || '');
        setProject(initialData.project || '');
        setAgentName(initialData.agentName || '');
        setAgentCommission(initialData.agentCommission || '');
        setRemark(initialData.remark || initialData.remarks || '');
        setSelectedLeadSource(initialData.selectedLeadSource || null);
        setSelectedEmployee(initialData.selectedEmployee || null);
        setSelectedActivity(initialData.selectedActivity || null);
        setSelectedStatus(initialData.selectedStatus || null);

        if (initialData.details) {
            if (Array.isArray(initialData.details)) {
                setDetails(initialData.details);
            } else if (typeof initialData.details === 'object') {
                const arr = Object.entries(initialData.details).map(([label, value]) => ({ label, value }));
                setDetails(arr);
            }
        } else {
            setDetails([
                { label: 'City', value: '' },
                { label: 'State', value: '' },
                { label: 'mobileNo', value: '' },
                { label: 'Email', value: '' },
                { label: 'ContactPerson', value: '' },
                { label: 'GST No.', value: '' },
            ]);
        }
    }, [initialData, mode]);
    // END NEW CHANGE

    // ─── fetch search results ─────────────────────────────────────────────
    // Debounced 350ms so a fast typist doesn't fire one API call per keystroke —
    // the search still starts automatically as the user types, just waits for a
    // brief pause before actually calling the API.
    useEffect(() => {
        if (!companyName || !dropdownOpen) {
            setSearchResults([]);
            return;
        }

        const timeoutId = setTimeout(() => {
            const fetch = async () => {
                try {
                    console.log('🌐 Fetching company search results for:', companyName);
                    const res = await axios.get(`${API}/api/company-search`, { params: { field: 'FirmName', search: companyName, companyId } });
                    // const data = Array.isArray(res.data.data) ? res.data.data : [];
                    const data = Array.isArray(res.data?.data) ? res.data.data : res.data;
                    console.log('✅ Company search results:', data);
                    setSearchResults(data);
                    setHighlightedIndex(0); // reset so the first result is highlighted for Enter-to-select
                } catch (err) {
                    console.error('❌ Error fetching company search:', err.message);
                    setSearchResults([]);
                }
            };
            fetch();
        }, 350);

        return () => clearTimeout(timeoutId);
    }, [companyName, dropdownOpen]);

    // ─── when the user clicks a row in the table ──────────────────────────
    const onSelectResult = r => {
        console.log('✅ Selected company:', r);
        setSelectedClientId(r.id);
        setCompanyName(r.FirmName);
        setAgentName(r.AgentName || '');
        setAgentCommission(r.AgentComm || '');

        const c = { city: r.City || '', state: r.state || '', mobileNo: r.MobileNo || '', emailId: r.EmailId || '', contactPerson: r.ContactPerson || '', gstNumber: r.GSTNo || '' };
        setDetails([
            { label: 'City', value: c.city },
            { label: 'State', value: c.state },
            { label: 'mobileNo', value: c.mobileNo },
            { label: 'Email', value: c.emailId },
            { label: 'ContactPerson', value: c.contactPerson },
            { label: 'GST No.', value: c.gstNumber }
        ]);
        setDropdownOpen(false);
        setClientError(false);
    };

    // ─── Next button ─────────────────────────────────────────────────────
    const handleNext = () => {
        if (!selectedClientId) {
            setClientError(true);
            return;
        }

        if (!qoutationNumber) {
            setError('Inquiry No. is required.');
            return;
        }

        if (new Date(qnextFollowUpDate) < new Date(qoutationDate)) {
            setError('Next follow-up must be after inquiry date.');
            return;
        }

        setError('');

        onNext({
            clientId: selectedClientId, companyName, qoutationNumber, inquiryDate: qoutationDate.format('DD/MM/YYYY'), referenceNumber, referenceDate: referenceDate?.format('DD/MM/YYYY') || null, agentName, agentCommission, currencyId: selectedCurrency?.id || null, exchangeRate, nextFollowUpDate: qnextFollowUpDate.format('DD/MM/YYYY'), kindAttend, remarks: remark, project, selectedEmployee, selectedLeadSource, selectedActivity, selectedStatus,
            TermsType: selectedTerms?.label || null,
            details: details.reduce((acc, curr) => {
                acc[curr.label] = curr.value;
                return acc;
            }, {})
        });
    };

    const handlePopupClose = (data) => {
        if (data?.success) {
            setSnackbar({ open: true, message: data.message, severity: "success" });
        }
    };

    // allow editing only in 'add' or 'edit' modes

    const isEditable = mode === 'add' || mode === 'edit';
    console.log("isEditable", isEditable)

    const clientExists = searchResults.some(r => r.FirmName?.toLowerCase() === companyName.trim().toLowerCase());

    return (
        <Paper sx={{ p: isSmallScreen ? 1 : 1, overflowX: 'hidden' }}>
            <Box display="flex" justifyContent="space-between" flexWrap="wrap" pt={1}>
                <Box sx={{ width: { xs: "100%", md: "calc(50% - 16px)" }, pr: { md: 3 } }}>
                    {/* Party dropdown */}
                    <Box ref={partyDropdownRef} tabIndex={-1} sx={{ position: 'relative', flex: '1 1 40%' }}
                        onBlur={e => {
                            if (!partyDropdownRef.current.contains(e.relatedTarget)) {
                                setDropdownOpen(false);
                            }
                        }}
                    >
                        {/* <TextField disabled={!isEditable} fullWidth size="small" label="Party Name" variant="outlined" value={companyName} required InputLabelProps={{ shrink: Boolean(companyName) }}
                            sx={{ '& .MuiOutlinedInput-root': { height: '40px', display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { padding: '0 12px' } }}
                            onChange={e => {
                                setCompanyName(e.target.value);
                                setDropdownOpen(true);
                            }}
                        /> */}
                        {/* // disabled={!isEditable} */}
                        <TextField autoFocus={mode === 'add'} disabled={disablePartyName || disablePartyNameEdit || isEditLocked} fullWidth size="small" label="Party Name" variant="outlined" value={toProperCase(companyName)} required error={clientError}
                            helperText={clientError ? "Client does not exist. Please add new client or select from the List" : ""}
                            InputLabelProps={{ shrink: Boolean(companyName), sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
                            onBlur={() => {
                                if (companyName && !selectedClientId) {
                                    setClientError(true);
                                }
                            }}
                            onChange={(e) => {
                                const value = toProperCase(e.target.value);
                                setCompanyName(value);
                                setSelectedClientId(null);   // invalidate
                                setDropdownOpen(true);
                                setClientError(false);
                            }}
                            onKeyDown={(e) => {
                                if (!dropdownOpen || searchResults.length === 0) return;
                                if (e.key === 'ArrowDown') {
                                    e.preventDefault();
                                    setHighlightedIndex((prev) => Math.min(prev + 1, searchResults.length - 1));
                                } else if (e.key === 'ArrowUp') {
                                    e.preventDefault();
                                    setHighlightedIndex((prev) => Math.max(prev - 1, 0));
                                } else if (e.key === 'Enter') {
                                    e.preventDefault();
                                    const selected = searchResults[highlightedIndex];
                                    if (selected) {
                                        onSelectResult(selected);
                                        setCompanyName(toProperCase(selected.FirmName));
                                        setClientError(false);
                                        setDropdownOpen(false);
                                    }
                                } else if (e.key === 'Escape') {
                                    setDropdownOpen(false);
                                }
                            }}
                        />

                        {dropdownOpen && companyName && (
                            <Paper elevation={0} sx={{ mt: 1, position: 'absolute', width: { xs: '100%', lg: '800px' }, zIndex: 10, border: '1px solid rgba(0,0,0,0.2)', borderRadius: 1, maxHeight: 240, overflowY: 'auto' }} >
                                {isSmallScreen ? (
                                    /* ===================== CARD VIEW (SM / XS) ===================== */
                                    <>
                                        {searchResults.length > 0 ? (
                                            searchResults.map((r, i) => (
                                                <Box key={i} sx={{ p: 1.2, borderBottom: `1px solid ${themeColors.neutral.border}`, cursor: 'pointer', backgroundColor: i === highlightedIndex ? 'action.selected' : 'transparent' }}
                                                    onMouseEnter={() => setHighlightedIndex(i)}
                                                    onMouseDown={() => {
                                                        onSelectResult(r);
                                                        // setSelectedClientId(r.ClientId);
                                                        setCompanyName(toProperCase(r.FirmName));
                                                        setClientError(false);
                                                        setDropdownOpen(false);
                                                    }}
                                                >
                                                    <Box sx={{ fontWeight: 600, fontSize: '0.85rem' }}>
                                                        {toProperCase(r.FirmName)}
                                                    </Box>

                                                    <Box sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
                                                        GST: {r.GSTNo || '-'}
                                                    </Box>

                                                    <Box sx={{ fontSize: '0.75rem' }}>
                                                        {toProperCase(r.ContactPerson) || '-'} • {r.MobileNo || '-'}
                                                    </Box>

                                                    <Box sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
                                                        {toProperCase(r.City) || '-'}
                                                    </Box>
                                                </Box>
                                            ))
                                        ) : (
                                            <Box sx={{ p: 2, textAlign: 'center', color: 'error.main' }}>
                                                Client not found
                                            </Box>
                                        )}

                                        {/* Sticky Add New Client */}
                                        <Box onMouseDown={() => setOpenClientPopup(true)} sx={{ position: 'sticky', bottom: 0, backgroundColor: themeColors.neutral.surface, textAlign: 'center', p: 1, fontWeight: 600, color: 'primary.main', cursor: 'pointer', boxShadow: '0 -2px 6px rgba(0,0,0,0.08)' }} >
                                            ➕ Add New Client
                                        </Box>
                                    </>
                                ) : (
                                    /* ===================== TABLE VIEW (MD / LG) ===================== */
                                    <Table size="small" stickyHeader>
                                        <TableHead>
                                            <TableRow>
                                                {['Company', 'GST No', 'Contact', 'Mobile', 'City'].map(h => (
                                                    <TableCell key={h} sx={{ backgroundColor: themeColors.neutral.line, fontWeight: 600, fontSize: '0.75rem', position: 'sticky', top: 0, zIndex: 1 }} >
                                                        {h}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {searchResults.length > 0 ? (
                                                searchResults.map((r, i) => (
                                                    <TableRow key={i} hover selected={i === highlightedIndex} sx={{ cursor: 'pointer' }}
                                                        onMouseEnter={() => setHighlightedIndex(i)}
                                                        onMouseDown={() => {
                                                            onSelectResult(r);
                                                            setCompanyName(toProperCase(r.FirmName));
                                                            setClientError(false);
                                                            setDropdownOpen(false);
                                                        }}
                                                    >
                                                        <TableCell>{toProperCase(r.FirmName)}</TableCell>
                                                        <TableCell>{r.GSTNo}</TableCell>
                                                        <TableCell>{toProperCase(r.ContactPerson)}</TableCell>
                                                        <TableCell>{r.MobileNo}</TableCell>
                                                        <TableCell>{toProperCase(r.City)}</TableCell>
                                                    </TableRow>
                                                ))
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={5} align="center" sx={{ color: 'error.main' }}>
                                                        Client not found
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>

                                        <TableFooter sx={{ position: 'sticky', bottom: 0, backgroundColor: themeColors.neutral.surface }} >
                                            <TableRow hover onMouseDown={() => setOpenClientPopup(true)}>
                                                <TableCell colSpan={5} align="center" sx={{ color: 'primary.main', fontWeight: 600 }}>
                                                    ➕ Add New Client
                                                </TableCell>
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                )}
                            </Paper>
                        )}


                    </Box>

                    {/* Details display */}
                    <Grid item xs={12} md={4} pt={2}>
                        <TextField fullWidth size="small" label="Address" variant="outlined" disabled value={Array.isArray(details) ? toProperCase(details.map(d => `${d.label}: ${d.value}`).join(', ')) : ''} multiline rows={2.5} InputLabelProps={{ shrink: Array.isArray(details) && details.length > 0 }} sx={{ '& .MuiOutlinedInput-root': { height: "auto", display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
                    </Grid>

                    <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField fullWidth size="small" label="Kind Attend" value={kindAttend} onChange={e => setKindAttend(e.target.value)} InputLabelProps={{ shrink: Boolean(kindAttend) }} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
                        </Box>
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField fullWidth size="small" label="Project" value={project} onChange={e => setProject(e.target.value)} InputLabelProps={{ shrink: Boolean(project) }} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
                        </Box>
                    </Box>
                    {/* Remark multiline (max 250 chars) */}
                    <Box sx={{ mt: 2 }}>
                        <TextField fullWidth size="small" label="Remark" disabled={!isEditable} multiline minRows={1} maxRows={6} value={remark} InputLabelProps={{ shrink: Boolean(remark) }} inputProps={{ maxLength: 250 }} sx={{ '& .MuiOutlinedInput-root': { height: 'auto', alignItems: 'flex-start' } }}
                            onChange={(e) => {
                                const val = e.target.value;
                                if (val.length <= 250) setRemark(val);
                                else setRemark(val.slice(0, 250));
                            }}
                        />
                        <Typography variant="caption" sx={{ display: 'block', mt: 0.5, textAlign: 'right', color: 'text.secondary' }}>
                            {remark.length}/250
                        </Typography>
                    </Box>

                    <Box display="flex" justifyContent="flex-start">
                        <Box sx={{ width: '20%', mt: "-8px" }}>
                            <Autocomplete
                                fullWidth
                                size="small"
                                options={termsOptions}
                                getOptionLabel={(opt) => opt?.label || ''}
                                value={selectedTerms}
                                onChange={(_, v) => setSelectedTerms(v)}
                                inputValue={termsInputValue}
                                onInputChange={(_, newInputValue) => setTermsInputValue(newInputValue)}
                                noOptionsText="Not Found"
                                isOptionEqualToValue={(opt, val) => String(opt?.id) === String(val?.id)}
                                // disabled={!isEditable}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Terms"
                                        size="small"
                                        InputLabelProps={{ shrink: Boolean(selectedTerms || termsInputValue) }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                height: 38,
                                                display: 'flex',
                                                alignItems: 'center'
                                            },
                                            '& .MuiOutlinedInput-input': {
                                                fontSize: '0.875rem',
                                                padding: '0 12px'
                                            }
                                        }}
                                    />
                                )}
                            />
                        </Box>
                    </Box>
                </Box>

                <Box sx={{ width: { xs: "100%", md: "calc(50% - 46px)" }, pt: { xs: 2, md: 0 } }} alignSelf="right">
                    {/* Quotation No + Date */}
                    <Box display="flex" gap={2} flex="1 1 40%" >
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField key={qoutationNumber} fullWidth size="small" label="Quotation No." variant='outlined' value={isFetchingQuotation ? 'Loading...' : qoutationNumber} disabled InputLabelProps={{ shrink: true }} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { padding: '0 12px' } }} />
                        </Box>

                        <Box sx={{ flex: '0 0 48%' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                <DatePicker label="Quotation Date" value={qoutationDate} onChange={setqoutationDate} minDate={dayjs(startDate)} maxDate={dayjs(endDate)}
                                    slots={{
                                        textField: (params) => (
                                            <TextField {...params} size="small" variant="outlined" value={qoutationDate ? dayjs(qoutationDate).format('DD/MM/YYYY') : ''} InputLabelProps={{ shrink: true }} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { padding: '0 12px' } }} />
                                        ),
                                    }}
                                />
                            </LocalizationProvider>
                        </Box>
                    </Box>

                    <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
                        {/* Ref. No. */}
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField fullWidth size="small" variant='outlined' label="Ref. No." value={referenceNumber} disabled={isEditLocked || mode === 'inquiry' || disablePartyNameEdit} onChange={e => setReferenceNumber(e.target.value)} InputLabelProps={{ shrink: Boolean(referenceNumber) }} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
                        </Box>

                        <Box sx={{ flex: '0 0 48%' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                <DatePicker label="Ref. Date" value={referenceDate} disabled={isEditLocked || mode === 'inquiry' || disablePartyNameEdit} onChange={(newValue) => { setReferenceDate(newValue); }}
                                    slots={{
                                        textField: (params) => (
                                            <TextField {...params} fullWidth size="small" variant="outlined" value={referenceDate ? dayjs(referenceDate).format('DD/MM/YYYY') : ''} InputLabelProps={{ shrink: Boolean(referenceDate) }} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
                                        )
                                    }}
                                />
                            </LocalizationProvider>
                        </Box>
                    </Box>

                    <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
                        {/* Combined Left Group — the slot stays reserved (flex: '0 0 48%')
                            even when hidden, so the Follow-Up Date box to the right doesn't
                            collapse into its place; only the field contents are conditional. */}
                        <Box sx={{ flex: '0 0 48%', display: 'flex', gap: 1, alignItems: 'center' }}>
                            {showCurrency && (
                                <>
                                    {/* Currency dropdown at 50% of this group */}
                                    <Box sx={{ flex: '0 0 50%' }}>
                                        {dropdownField('Currency', currencyOptions, selectedCurrency, setSelectedCurrency)}
                                    </Box>

                                    {/* Exchange Rate at 47% of this group */}
                                    <Box sx={{ flex: '0 0 47%' }}>
                                        <TextField fullWidth size="small" type="number" variant="outlined" label="Ex Rate" value={exchangeRate} InputLabelProps={{ shrink: Boolean(exchangeRate) }} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d*\.?\d{0,2}$/.test(value)) {
                                                    setExchangeRate(value);
                                                }
                                            }}
                                        />
                                    </Box>
                                </>
                            )}
                        </Box>

                        {/* Right group: Follow-Up Date */}
                        <Box sx={{ flex: '0 0 48%' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                <DatePicker minDate={qoutationDate ? dayjs(qoutationDate) : undefined} label="Follow Up Date" value={qnextFollowUpDate} onChange={(newValue) => { setqnextFollowUpDate(newValue); }}
                                    slots={{
                                        textField: (params) => (
                                            <TextField {...params} fullWidth size="small" variant="outlined" value={qnextFollowUpDate ? qnextFollowUpDate.format('DD/MM/YYYY') : ''} InputLabelProps={{ shrink: Boolean(qnextFollowUpDate) }} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
                                        )
                                    }}
                                />
                            </LocalizationProvider>
                        </Box>
                    </Box>

                    <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField fullWidth label="Agent Name" value={toProperCase(agentName)} onChange={e => setAgentName(toProperCase(e.target.value))} InputLabelProps={{ shrink: Boolean(agentName) }} variant="outlined" size="small" sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
                        </Box>

                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField fullWidth label="Agent Commission (%)" value={agentCommission} InputLabelProps={{ shrink: Boolean(agentCommission) }} variant="outlined" size="small" type="number" sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
                                onChange={e => {
                                    const v = e.target.value;
                                    if (v === '') {
                                        setAgentCommission('');
                                        return;
                                    }
                                    const re = /^(?:100(?:\.(?:0{0,2}))?|[0-9]{1,2}(?:\.\d{0,2})?)$/;
                                    if (re.test(v)) {
                                        setAgentCommission(v);
                                    }
                                }}
                            />
                        </Box>
                    </Box>
                </Box>
            </Box>

            {!!error && (
                <Typography color="error" mt={2}>
                    {error}
                </Typography>
            )}

            {isFetchingQuotation && (
                <Typography color="text.secondary" mt={2}>
                    Loading quotation number...
                </Typography>
            )}

            <Box mt={4} display="flex" justifyContent="flex-end">
                <Button variant="contained" onClick={handleNext} disabled={isFetchingQuotation || !selectedClientId}> Next </Button>
            </Box>

            {/* Popups */}
            <Dialog open={openClientPopup} fullWidth maxWidth="md" onClose={(event, reason) => {
                if (reason === 'backdropClick') return;
                setOpenClientPopup(false);
            }}
                PaperProps={{
                    sx: {
                        width: { xs: "95%", },
                        m: { xs: 0 }
                    }
                }}>
                <DialogContent sx={{ p: { xs: 0 } }}>
                    <ClientMaster mode="add" onPopupCancel={(data) => { handlePopupClose(data); setOpenClientPopup(false) }} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openCurrencyPopup} onClose={() => setOpenCurrencyPopup(false)}>
                <DialogContent>
                    <CurrencyMaster mode="add" onPopupCancel={() => setOpenCurrencyPopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openLeadSourcePopup} onClose={() => setOpenLeadSourcePopup(false)}>
                <DialogContent>
                    <LeadSourceMaster mode="add" onPopupCancel={() => setOpenLeadSourcePopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openEmployeePopup} onClose={() => setOpenEmployeePopup(false)}>
                <DialogContent>
                    <UserMaster mode="add" onPopupCancel={() => setOpenEmployeePopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openActivityPopup} onClose={() => setOpenActivityPopup(false)}>
                <DialogContent>
                    <ActivityMaster mode="add" onPopupCancel={() => setOpenActivityPopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openStatusPopup} onClose={() => setOpenStatusPopup(false)}>
                <DialogContent>
                    <LeadStatusMaster mode="add" onPopupCancel={() => setOpenStatusPopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>

            <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
                <Alert onClose={() => setSnackbar(s => ({ ...s, open: false }))} severity={snackbar.severity} variant="filled" sx={{ width: '100%' }} >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Paper>
    );
}
